export default __webpack_public_path__ + "static/media/blank.0041ba29.jpg";